"use client";

import { Button, Drawer, Typography } from "@shared/ui.primitives";
import { dispatch } from "@shared/utils.events";
import { useTrackElementViewed } from "packages/membership/tracking";
import React, { useState } from "react";

import * as styles from "./ProductInfoSection.css";

type Props = {
  title: string;
  textContent?: string;
  buttonText?: string;
};

export const ProductInfoSection: React.FC<Props> = ({
  title,
  textContent,
  buttonText = "View All"
}) => {
  const { ref } = useTrackElementViewed({
    target: title,
    location: "PDP"
  });

  const [isOpen, setIsOpen] = useState(false);

  if (!textContent) return null;

  const showModal = () => {
    dispatch("page element clicked", {
      target: title,
      details: buttonText,
      location: "PDP"
    });
    setIsOpen(true);
  };

  const handleDismiss = () => {
    dispatch("page element clicked", {
      target: title,
      details: "close",
      location: "PDP"
    });
    setIsOpen(false);
  };

  return (
    <>
      <div className={styles.container} ref={ref}>
        <Typography as="h4" variant="subheader-4">
          {title}
        </Typography>
        <Typography variant="link-xs" color="primary-medium">
          <Button
            variant="link"
            width="minContent"
            onClick={showModal}
            text={buttonText}
            size="small"
          ></Button>
        </Typography>
      </div>

      <Drawer
        isOpen={isOpen}
        handleDismiss={handleDismiss}
        ariaDescription={`Learn more about ${title}`}
        ariaLabel={title}
        id="product-info-drawer"
        dataTestId="product-info-drawer"
        headerId="product-info-drawer-header"
      >
        <Drawer.Header
          handleDismiss={handleDismiss}
          id="product-info-drawer-header"
        >
          {title}
        </Drawer.Header>
        <Drawer.Body>
          <Typography as="p" variant="body-md">
            {textContent}
          </Typography>
        </Drawer.Body>
        <Drawer.Footer>
          <Button
            width="full"
            variant="secondary"
            onClick={handleDismiss}
            text="Back to product page"
          />
        </Drawer.Footer>
      </Drawer>
    </>
  );
};
